import { createFileRoute } from "@tanstack/react-router";
import { AiTeammatesMarketingSeoPage } from "@/components/seo/ai-teammates-marketing-seo-page";
import {
	AI_TEAMMATES_MARKETING_SEO_FAQ_SCHEMA_ITEMS,
	AI_TEAMMATES_MARKETING_SEO_META_DESCRIPTION,
	AI_TEAMMATES_MARKETING_SEO_PAGE_TITLE,
} from "@/constants/seo/ai-teammates-marketing-seo-content";
import {
	buildBreadcrumb,
	buildFAQ,
	buildSoftwareApplication,
	buildWebPage,
	jsonLdScript,
} from "@/lib/seo/json-ld";
import { buildLinks, buildMetaTags, getCanonical } from "@/lib/seo/meta";

export const Route = createFileRoute("/ai-teammates/marketing/seo")({
	head: () => {
		const canonical = getCanonical("/ai-teammates/marketing/seo");
		const meta = buildMetaTags({
			title: "AI SEO Tool – Search Console Monitoring & Reports",
			description: AI_TEAMMATES_MARKETING_SEO_META_DESCRIPTION,
			canonical,
			ogType: "website",
		});

		const schemas = [
			buildWebPage({
				name: AI_TEAMMATES_MARKETING_SEO_PAGE_TITLE,
				description: AI_TEAMMATES_MARKETING_SEO_META_DESCRIPTION,
				url: canonical,
			}),
			buildFAQ(AI_TEAMMATES_MARKETING_SEO_FAQ_SCHEMA_ITEMS),
			buildBreadcrumb([
				{ name: "Home", url: getCanonical("/") },
				{ name: "AI Teammates", url: getCanonical("/ai-teammates") },
				{ name: "Marketing", url: getCanonical("/ai-teammates/marketing") },
				{ name: "SEO", url: canonical },
			]),
			buildSoftwareApplication({ ratingValue: 4.8, ratingCount: 50, price: "0" }),
		];

		return {
			meta,
			links: buildLinks({ canonical }),
			scripts: schemas.map(jsonLdScript),
		};
	},
	component: AiTeammatesMarketingSeoPage,
});
